// bootstrap import
// import "bootstrap"

import Loader from './parts/Loader.js'
import Navigation from './parts/Navigation.js'
import Smooth from './parts/Smooth.js'
// import Accordion from './parts/Accordion.js'
// import MouseStalker from './parts/MouseStalker.js'
// import Swiper from 'swiper/bundle'
// import 'swiper/swiper-bundle.css'

import { gsap } from 'gsap'
import { ScrollSmoother } from 'gsap/ScrollSmoother'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

// スムーススクロール実装
//----------------------------------------------------
gsap.registerPlugin(ScrollTrigger, ScrollSmoother)

// ----------------------------------------------------
// ナビゲーション
// ----------------------------------------------------
new Navigation({
  navId: 'site_navigation', // 対象となるnavタグのID
  humId: 'hum_toggle', // ハンバーガーメニューのID
  linkSelector: '#site_navigation a', // 対象となるaタグのセレクタ
  breakPoint: 1025, // PCとSPのブレイクポイント
  pcNavigation: true, // PCでもナビゲーションを使用する場合はtrue
})

// ----------------------------------------------------
// ローダー
// ----------------------------------------------------
new Loader({
  endFn: () => {
    setTimeout(() => {
      const loader = document.getElementById('loader')
      loader?.classList.add('loadOp')

      setTimeout(() => {
        loader?.classList.add('loadend')
      }, 1000)

      console.log('load end')
    }, 1500) // ここが「ロゴを見せる時間」。1.5秒〜2秒くらいがおすすめ
  },
})

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
new Smooth({
  linkTarget: '.nav_link a[href*="#"]',
  breakPoint: 768, // px
  pcWaitTime: 500, // ms
  spWaitTime: 500, // ms
  exceptionId: ['exceptionId'], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
  },
})
// ----------------------------------------------------
// 右エリア画像切り替え（スクロール位置ベース版）
// ----------------------------------------------------

const targets = Array.from(
  document.querySelectorAll<HTMLElement>('[data-target]'),
)

// グループ単位で取得
const sideGroups = Array.from(
  document.querySelectorAll<HTMLElement>('.js-side-group'),
)

function updateActiveImage() {
  const scrollY = window.scrollY
  const vh = window.innerHeight
  const centerY = scrollY + vh / 2

  let selected: HTMLElement | null = null
  let min = Infinity

  targets.forEach((el) => {
    const rect = el.getBoundingClientRect()
    const elCenter = scrollY + rect.top + rect.height / 2
    const dist = Math.abs(centerY - elCenter)

    if (dist < min) {
      min = dist
      selected = el
    }
  })

  if (!selected) return

  const targetId = selected.dataset.target
  const isAtTop = window.scrollY < 50
  const finalId = isAtTop ? 'img-0' : targetId

  const targetGroup = document.querySelector(
    `.js-side-group[data-img-id="${finalId}"]`,
  )

  if (!targetGroup) return

  sideGroups.forEach((group) => {
    group.classList.remove('is-active')
  })

  targetGroup.classList.add('is-active')
}

window.addEventListener('scroll', () => {
  requestAnimationFrame(updateActiveImage)
})

window.addEventListener('load', () => {
  updateActiveImage()
})
updateActiveImage()
// ----------------------------------------------------
// ナビ
// ----------------------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const navToggle = document.getElementById('nav_toggle')
  const navMenu = document.getElementById('nav_menu')

  const navLinks = document.querySelectorAll('.js-nav-link')

  if (navToggle && navMenu) {
    navToggle.addEventListener('click', () => {
      navToggle.classList.toggle('is-active')
      navMenu.classList.toggle('is-active')
    })
  }

  navLinks.forEach((link) => {
    link.addEventListener('click', (e: Event) => {
      const anchorLink = link as HTMLAnchorElement
      const targetHash = anchorLink.hash
      const isTopPage =
        window.location.pathname === '/' ||
        window.location.pathname === '/index.html'

      navToggle?.classList.remove('is-active')
      navMenu?.classList.remove('is-active')

      if (isTopPage) {
        if (targetHash) {
          e.preventDefault()

          if (targetHash === '#top') {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            history.replaceState(null, '', window.location.pathname)
          } else {
            const targetElement = document.querySelector(targetHash)
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: 'smooth' })
              history.pushState(null, '', targetHash)
            }
          }
        }
      } else {
        e.preventDefault()

        const destination = targetHash === '#top' ? '/' : `/${targetHash}`
        window.location.href = destination
      }
    })
  })
})

// ----------------------------------------------------
// 動画
// ----------------------------------------------------
const wrapper = document.getElementById('videoWrapper')
const video = document.getElementById('myVideo')

wrapper.addEventListener('click', (e) => {
  if (document.fullscreenElement || wrapper.classList.contains('is_playing')) {
    return
  }

  video
    .play()
    .then(() => {
      video.controls = true
      wrapper.classList.add('is_playing')
    })
    .catch((error) => {
      console.error('Playback failed:', error)
    })
})

document.addEventListener('fullscreenchange', () => {
  if (document.fullscreenElement) {
    video.controls = true
    video.style.pointerEvents = 'auto'
  } else if (!video.paused) {
    video.controls = true
    video.style.pointerEvents = 'auto'
  }
})

video.addEventListener('ended', () => {
  video.controls = false
  wrapper.classList.remove('is_playing')
  video.load()
})
